/* Collapsible help section component (split from CDMDocumentsSettings.jsx) */
import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export function HelpSection({ title, icon, id, expanded, setExpanded, defaultOpen, children }) {
  const isOpen = expanded[id] !== undefined ? expanded[id] : !!defaultOpen;
  const toggle = () => setExpanded(prev => ({ ...prev, [id]: !isOpen }));

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden" data-testid={`help-section-${id}`}>
      <button
        type="button"
        onClick={toggle}
        className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
      >
        <div className="flex items-center gap-2">
          {icon}
          <span className="font-medium text-gray-900 text-sm">{title}</span>
        </div>
        {isOpen ? <ChevronUp className="h-4 w-4 text-gray-500" /> : <ChevronDown className="h-4 w-4 text-gray-500" />}
      </button>
      {isOpen && (
        <div className="px-4 py-3 text-gray-600">
          {children}
        </div>
      )}
    </div>
  );
}
